<template>
  <div class="related-content-container">
    <div class="inner-content">
      <h2>You may also be interested&nbsp;in:</h2>
      <slot name="related-content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style lang="scss" scoped>
.related-content-container {
  background-color: $grey-light;
  z-index: 2;
  h2 {
    color: #000;
    font-size: 1.5rem;
    margin: 0;
    margin-bottom: 10px;
  }

  ::v-deep ul {
    list-style: none;
    padding-left: 0;
    margin: 0;

    li {
      font-size: 1rem;
      margin: 0;
      margin-bottom: 10px;
      color: $black;
      display: flex;
      align-items: center;
      text-decoration: underline;
      &:hover {
        text-decoration: none;
        cursor: pointer;
      }
      img {
        width: 12px * 2;
        height: 19px * 2;
        margin-right: 20px;
        &.thumbnail {
          width: 86px;
          height: auto;
          border: 1px solid $grey-darkest;
        }
      }
      &:last-child {
        margin-bottom: 0;
      }

      .pdf-button {
        background: transparent;
        border: none;
        text-decoration: underline;
      }
    }
  }

  .inner-content {
    margin: 0 auto;
    padding-top: rem(30px);
    padding-bottom: rem(30px);
    display: flex;
    flex-direction: column;
  }
}
</style>
